<app-base-auth-form
  [message]="'Auth.LoginMessage' | i18next"
  [action]="'Auth.Login' | i18next"
  slot="main-content"
  [isBusy]="isBusy"
  [errorMessage]="errorMessage"
  (performAction)="login()"
>
  
  <div *ngIf="isInvitationContext" class="invitation-message item large-top-space">
    <div class="invitation-info">
      <i class="dx-icon-email"></i>
      <span>{{ 'Auth.InvitationLoginMessage' | i18next }}</span>
    </div>
  </div>

  <dx-text-box
    [label]="'Auth.Username' | i18next"
    labelMode="floating"
    valueChangeEvent="input"
    [class]="isInvitationContext ? 'item top-space' : 'item large-top-space'"
    [(value)]="username"
    (valueChange)="resetError()"
  ></dx-text-box>

  <dx-text-box
    [label]="'Auth.Password' | i18next"
    labelMode="floating"
    [mode]="passwordFieldMode"
    valueChangeEvent="input"
    class="item top-space"
    [(value)]="password"
    (valueChange)="resetError()"
    (onEnterKey)="login()"
  >
    <dxi-button
      name="toggleVisibility"
      location="after"
      [options]="passwordButtonOptions"
    >
    </dxi-button>
  </dx-text-box>

  <a
    (click)="navigateToResetPassword()"
    class="item top-space"
    id="forget-password-link"
    style="cursor: pointer;"
  >
    {{ "Auth.ForgotPassword" | i18next }}
  </a>

  <a
    (click)="navigateToSignup()"
    class="item top-space"
    id="signup-link"
    style="cursor: pointer;"
  >
    {{ "Auth.Register" | i18next }}
  </a>
</app-base-auth-form>
